import React, { Fragment } from 'react'
import DangerDropdownMenuItem from 'components/DangerDropdownMenuItem'
import DeleteFeatureGroupMutation from 'components/mutations/DeleteFeatureGroup'
import DeleteGroupModal from './components/DeleteGroupModal'
import ListBox from 'components/ListBox'
import ListRow from 'components/ListRow'
import MoreMenu from 'components/MoreMenu'
import PageHeader from 'components/PageHeader'
import Toggle from 'components/Toggle'
import RouteAdminFeaturesGroupsIndexQuery from './index.query'
import { ButtonLink, DropdownMenu, UsersIcon } from 'stylist'
import { Query } from 'react-apollo'

const RouteAdminFeaturesGroupsIndex = ({ match: { url } }) => (
  <Query query={RouteAdminFeaturesGroupsIndexQuery}>
    {({ loading, data: { features, groups = [] } }) => (
      <Fragment>
        <PageHeader columns="auto 1fr auto">
          <PageHeader.Icon>
            <UsersIcon />
          </PageHeader.Icon>
          <PageHeader.Title>Groups</PageHeader.Title>
          <ButtonLink kind="ghost" to={`${url}/new`}>
            Add Group
          </ButtonLink>
        </PageHeader>
        <article>
          <ListBox>
            {loading ? (
              <ListBox.Loader />
            ) : (
              groups.map(group => (
                <ListBox.Item hover key={group.id}>
                  <ListRow templateColumns="1fr auto">
                    <ListRow.Cell>
                      <ListRow.TitleLink to={`${url}/${group.id}`}>
                        <strong>{group.name}</strong>
                      </ListRow.TitleLink>
                    </ListRow.Cell>
                    <ListRow.Cell actions>
                      <MoreMenu horizontal>
                        <DropdownMenu.Section>
                          <DropdownMenu.Item to={`${url}/${group.id}/features`}>
                            Features
                          </DropdownMenu.Item>
                          <DropdownMenu.Item to={`${url}/${group.id}/users`}>
                            Users
                          </DropdownMenu.Item>
                        </DropdownMenu.Section>
                        <Toggle
                          initial={false}
                          render={({ on, enable, disable }) => (
                            <DropdownMenu.Section>
                              <DangerDropdownMenuItem to="#" onClick={enable}>
                                Delete group
                              </DangerDropdownMenuItem>
                              <DeleteFeatureGroupMutation group={group}>
                                {({ deleteGroup }) => (
                                  <DeleteGroupModal
                                    open={on}
                                    onClose={disable}
                                    group={group}
                                    onDelete={deleteGroup}
                                  />
                                )}
                              </DeleteFeatureGroupMutation>
                            </DropdownMenu.Section>
                          )}
                        />
                      </MoreMenu>
                    </ListRow.Cell>
                  </ListRow>
                </ListBox.Item>
              ))
            )}
          </ListBox>
        </article>
      </Fragment>
    )}
  </Query>
)

export default RouteAdminFeaturesGroupsIndex



// WEBPACK FOOTER //
// ./src/routes/admin/features/groups/index.js